export const Lang = {
  title: 'St Andrews Links',
  subTitle: 'Content Management System',
  buttonText: 'Log In',
  inputs: {
    email: 'Email Address',
    password: 'Password',
  },
  copyright: 'Copyright St Andrews 2018',
};
